import { defineMessages } from 'react-intl';

export const messages: {
    searchSuggestionsDropdown: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	searchSuggestionsDropdown: {
		id: 'search-page.dropdown.search-suggestions',
		defaultMessage: 'Search Suggestions Dropdown',
		description: 'Aria label for search suggestions dropdown',
	},
});
